import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserAreaComponent } from './user-area.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiManagementComponent } from './components/api-management/api-management.component';
import { SharedModule } from '../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { CreditsComponent } from './components/credits/credits.component';
@NgModule({
    declarations: [
        UserAreaComponent,
        ApiManagementComponent,
        ProfilePageComponent,
        CreditsComponent,
    ],
    exports: [UserAreaComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatDialogModule,
        ClipboardModule,
        NgbPaginationModule,
    ],
})
export class UserAreaModule {}
